import { render, staticRenderFns } from "./bf-grid.vue?vue&type=template&id=6b1e23d4&scoped=true&lang=pug&"
import script from "./bf-grid.vue?vue&type=script&lang=js&"
export * from "./bf-grid.vue?vue&type=script&lang=js&"
import style0 from "./bf-grid.vue?vue&type=style&index=0&id=6b1e23d4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e23d4",
  null
  
)

export default component.exports